var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M5.4,11.5v-0.6c0-0.2,0.2-0.3,0.4-0.4 c0.1,0,0.1,0,0.2-0.1l3.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M11.2,9.4l3.1,1c0.1,0,0.1,0,0.2,0.1 c0.2,0.1,0.4,0.2,0.4,0.4v0.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M11.2,9.1v0.6c0,0.6-0.5,0.7-1.1,0.7l0,0 C9.5,10.4,9,10.3,9,9.7V9.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.3,5.9C7.1,6,7.1,6.3,7.2,6.6 c0.1,0.3,0.3,0.5,0.5,0.5C8,8.4,9,9.4,10.2,9.4s2.2-1,2.5-2.3C12.9,7,13,6.8,13.1,6.6c0.1-0.3,0-0.6-0.2-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.5,6.5L7.3,5.8C6.8,4.2,7.4,3.2,7.4,3.2 c0.9-1.7,3.1-1.5,3.1-1.5S12.4,2,13,3.5c0,0,0.6,1.4-0.4,3l-0.3-0.9c0,0-0.8-0.5-0.9-1.6c0,0-0.4,1.2-2,1.6c0,0,0.3-0.7,0.4-1.2 c0,0-0.6,1.4-2,1.4L7.5,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M3.9,13.1l-0.1-1.7c0,0,0-0.3,0.3-0.2l5.4,1.1 c0,0,0.3,0,0.3,0.4c0,0,0.3,0.2,0.7,0c0,0-0.1-0.3,0.5-0.4l5.2-1.1c0,0,0.4-0.2,0.4,0.3l-0.1,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M16.2,15.6l-0.1,1.3c0,0,0.1,0.3-0.4,0.4 l-4.8,0.8c0,0-0.7,0.6-1.6,0l-4.9-0.9c0,0-0.3,0-0.3-0.4L4,15.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9975 -0.0705 0.0705 0.9975 -1.0049 0.3107)",
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 9.9999
    },
    cx: 3.902,
    cy: 14.4,
    rx: 0.7,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0705 -0.9975 0.9975 0.0705 0.9412 29.7866)",
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 9.9999
    },
    cx: 16.453,
    cy: 14.388,
    rx: 1.3,
    ry: 0.7
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.4e7bf9494680a71f22f2183f1a6ca09f.svg";
export { ForwardRef as ReactComponent };